/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs */

const en_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Bottom Right`)
};

const fr_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner en bas a droite`)
};

const de_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position unten rechts`)
};

const it_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione in basso a destra`)
};

const ru_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расположение: Нижний правый угол`)
};

const es_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición inferior derecha`)
};

const zh_cn2_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置右下角`)
};

const ja_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右下の位置`)
};

const hi_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नीचे दाईं ओर स्थित करें`)
};

const pt_pt2_shortcut_keys_name_cc_position_bottom_right = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição inferior direita`)
};

/**
* | output |
* | --- |
* | "Position Bottom Right" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_bottom_right = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Bottom_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cc_position_bottom_right(inputs)
	if (locale === "de") return de_shortcut_keys_name_cc_position_bottom_right(inputs)
	if (locale === "it") return it_shortcut_keys_name_cc_position_bottom_right(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cc_position_bottom_right(inputs)
	if (locale === "es") return es_shortcut_keys_name_cc_position_bottom_right(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cc_position_bottom_right(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cc_position_bottom_right(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cc_position_bottom_right(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cc_position_bottom_right(inputs)
	return en_shortcut_keys_name_cc_position_bottom_right(inputs)
});